import React from 'react';
import { useNavigate } from 'react-router-dom';
import './page-not-found.scss';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="page-not-found-container">
      <div className="page-not-found-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-message">
          The page you are looking for does not exist or you do not have
          permission to access it.
        </p>
        <button
          className="btn-go-back"
          onClick={() => navigate('/dashboard', { replace: true })}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
